import { getSelectedCinemaGroup } from './get-selected-cinema-group'

export const getSelectedCinemaGroupSiteIds = () => {
    return (
        (getSelectedCinemaGroup()
            ?.cinemas?.map(cinema => cinema.vistaCinema?.key)
            .filter(Boolean) as string[]) ?? []
    )
}
